
export enum UploadFileType {
    USER = 'USER_FILE',
    SCR = 'SCR_FILE',
    CATAPULT = 'CATAPULT_FILE',
    DOCKER_FILE = 'DOCKER_FILE',
    DOCKER_COMPOSE = 'DOCKER_COMPOSE'
}

export enum UploadFileCategory {
    FTM = 'FTM',
    ARTIFACT = 'ARTIFACT',
}

export type ArtifactUploadFileType = UploadFileType.CATAPULT | UploadFileType.DOCKER_FILE | UploadFileType.DOCKER_COMPOSE;

export const ARTIFACT_UPLOAD_FILE_TYPES: ArtifactUploadFileType[] = [UploadFileType.CATAPULT, UploadFileType.DOCKER_FILE, UploadFileType.DOCKER_COMPOSE];

export const ARTIFACT_UPLOAD_FILE_TYPE_LABELS: Record<ArtifactUploadFileType, string> = {
    [UploadFileType.CATAPULT]: 'Catapult',
    [UploadFileType.DOCKER_FILE]: 'Docker File',
    [UploadFileType.DOCKER_COMPOSE]: 'Docker Compose'
};

export const ARTIFACT_ALLOWED_EXTENSIONS: Record<ArtifactUploadFileType, string[]> = {
    [UploadFileType.CATAPULT]: ['.zip'],
    [UploadFileType.DOCKER_FILE]: [],
    [UploadFileType.DOCKER_COMPOSE]: ['.yaml', '.yml']
};

export interface IUploadFileRequest {
    description?: string;
    type?: UploadFileType;
    category?: UploadFileCategory;
}
export interface IGetUploadedFileQuery {
    type?: UploadFileType;
    offset?: number;
    limit?: number;
    includeSharedFiles?: boolean;
}
export interface IUploadFileResponse {
    uploadedFile: UploadFileDto;
}

export interface IGetUploadedFileResponse extends IUploadFileResponse { }

export interface IGetUploadedFilesResponse {
    uploadedFiles: UploadFileDto[];
}

export interface IDeleteUploadedFileResponse {
    deleted: boolean;
}

export class UploadFileDto {
    constructor(private readonly _object: unknown) {
    }
    get uuid(): string {
        return this._object['uuid'] || '';
    }
    get accountUuid(): string {
        return this._object['accountUuid'] || '';
    }
    get fileName(): string {
        return this._object['fileName'] || '';
    }
    get type(): UploadFileType {
        if (!this._object['type'] || !Object.values(UploadFileType).includes(this._object['type'])) {
            return UploadFileType.USER;
        }
        return this._object['type'];
    }
    get category(): string {
        return this._object['category'] || '';
    }
    get awsArn(): string {
        return this._object['awsArn'] || '';
    }
    get description(): string {
        return this._object['description'] || '';
    }
    get updatedAt(): Date {
        return this._object['updatedAt'] ? new Date(this._object['updatedAt']) : null;
    }
    get createdAt(): Date {
        return this._object['createdAt'] ? new Date(this._object['createdAt']) : null;
    }
}
